import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrls: ['./notification-item.component.css']
})
export class NotificationItemComponent implements OnInit {

    @Input('notification') notification: any;
    notificationDate: any;

    constructor(private router: Router) {

    }

    ngOnInit() {
        this.notificationDate = new Date(this.notification.created_at);


    }

    goToDetails() {
        this.router.navigateByUrl('/admin/notification-details/' + this.notification.id);
    }


}
